// SPDX-License-Identifier: MIT
// SAS URL classification and lightweight rate-limit guard

export function classifySasIssues(url: string): string | undefined {
  try {
    const u = new URL(url);
    const p = u.searchParams;
    const spr = p.get('spr');
    if (spr && spr.toLowerCase().includes('http') && !spr.toLowerCase().includes('https'))
      return 'INSECURE_PROTOCOL';
    const se = p.get('se');
    if (se) {
      const exp = Date.parse(se);
      if (!Number.isNaN(exp) && exp < Date.now()) return 'EXPIRED';
    }
    return undefined;
  } catch {
    return 'PARSE_ERROR';
  }
}

// Lightweight production-only rate limiter for authentication attempts
// Protects against rapid, repeated connection attempts (e.g., brute testing tokens)
const RATE_WINDOW_MS = 10_000; // 10s window
const RATE_MAX_ATTEMPTS = 10; // max attempts per window
let authAttemptTimestamps: number[] = [];

export function allowAuthAttempt(): boolean {
  try {
    const isE2EMock = (import.meta as any)?.env?.VITE_E2E_MOCK === '1';
    const isProd = Boolean((import.meta as any)?.env?.PROD);
    const nodeEnv = typeof process !== 'undefined' ? (process as any).env?.NODE_ENV : undefined;
    if (isE2EMock || nodeEnv === 'test' || !isProd) return true; // only enforce in real production
    const now = Date.now();
    authAttemptTimestamps = authAttemptTimestamps.filter(t => now - t < RATE_WINDOW_MS);
    if (authAttemptTimestamps.length >= RATE_MAX_ATTEMPTS) return false;
    authAttemptTimestamps.push(now);
    return true;
  } catch {
    return true; // fail-open on environment detection errors
  }
}
